import { render, staticRenderFns } from "./DocumentTemplateDetailEditForm.vue?vue&type=template&id=6030a307"
import script from "./DocumentTemplateDetailEditForm.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateDetailEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports